<template>
    <v-navigation-drawer
        dark
        mini-variant
        mini-variant-width="270"
        permanent
        color="#131410"
        class="locale-font">

        <v-divider/>
        <div>
            <img
                class="pl-6 default"
                src="@/assets/olaf-logo-white.png">
        </div>

        <branch-select
            @select-sidebar="setActiveMenu"
            @clear-sidebar="clearSidebar()"/>

        <span class="sidebar px-2">
            <v-divider/>
        </span>
        <v-list
            v-if="showSidebar"
            dense
            nav>
            <v-list-item
                v-for="item in sidebar"
                :key="item.title">
                <v-list-item-content
                    :class="item.mode"
                    @click.stop="go(item.mode, item.path, item.pathName, item.title)">
                    <div
                        v-if="item.mode === 'normal' || item.mode === 'lineService'"
                        class="sidebar-item px-4 pt-2 pb-2 no-highlight">
                        <i
                            :class="[{ 'active-icon': item.active }, item.icon]"
                            class="ml-2 mr-3 icon">
                        </i>
                        <div
                            class="mt-1"
                            :class="[{'active-menu': item.active}]">
                            {{ item.title }}
                        </div>
                    </div>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <template v-slot:append>
            <div class="pb-6">
                <div class="pl-3 white-text no-highlight logout-menu">
                    <i
                        @click="logout()"
                        class="mt-1 ml-2 mr-3 sign-out-icon fas fa-sign-out-alt">
                    </i>
                    <div
                        class="ml-2 mb-2 pointer"
                        @click="logout()">
                        {{ $vuetify.lang.t('$vuetify.sidebar.logOut') }}
                    </div>
                </div>
                <div class="pl-3 white-text power-by">
                    {{ $vuetify.lang.t('$vuetify.sidebar.powerdBy') }}
                </div>
                <div class="pl-3 pt-4 version">
                    {{ $util.getVersionLabel() }}
                </div>
            </div>
      </template>

    <logout-modal
        ref="logoutModal"/>

    <line-modal
        ref="lineModal"/>

    </v-navigation-drawer>
</template>
<script>
import LogoutModal from '@/components/modal/LogoutModal'
import LineModal from '@/components/modal/LineModal'
import BranchSelect from '@/components/BranchSelect'
import permissionConstant from '@/constants/permissions.js'

export default {
    data () {
        return {
            items: [
                {
                    title: this.$vuetify.lang.t('$vuetify.sidebar.dashboard'),
                    icon: 'fas fa-tachometer-alt-fast',
                    path: 'Dashboard',
                    pathName: 'dashboard',
                    active: false,
                    mode: 'normal',
                    permission: [
                        permissionConstant.inquiry.view,
                        permissionConstant.attendance.view
                    ]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.sidebar.inquiryAttendance'),
                    icon: 'fas fa-clipboard-user',
                    path: 'InquiryAndAttendance',
                    pathName: 'inquiry-and-attendance',
                    active: false,
                    mode: 'normal',
                    permission: [
                        permissionConstant.inquiry.view,
                        permissionConstant.attendance.view
                    ]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.sidebar.employeeManagement'),
                    icon: 'fas fa-plus-circle',
                    path: 'Employees',
                    pathName: 'employees',
                    active: false,
                    mode: 'normal',
                    permission: [
                        permissionConstant.employee.view
                    ]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.sidebar.pin'),
                    icon: 'fas fa-calculator',
                    path: 'Pin',
                    pathName: 'pin',
                    active: false,
                    permission: [
                        permissionConstant.employee.view
                    ],
                    mode: 'normal'
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.sidebar.messageManagement'),
                    icon: 'fas fa-envelope',
                    path: 'Message',
                    pathName: 'message',
                    active: false,
                    mode: 'normal',
                    permission: [
                        // permissionConstant.billboard.view,
                        // permissionConstant.individual.view
                    ]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.sidebar.timableSettings'),
                    icon: 'fas fa-alarm-clock',
                    path: 'TimeTableSetting',
                    pathName: 'time-table-setting',
                    active: false,
                    mode: 'normal',
                    permission: [
                        permissionConstant.groupWorkday.view,
                        permissionConstant.specialWorkday.view
                    ]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.sidebar.report'),
                    icon: 'fas fa-file-alt',
                    path: 'Report',
                    pathName: 'report',
                    active: false,
                    permission: [
                        permissionConstant.report.view
                    ],
                    mode: 'normal'
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.sidebar.visitor'),
                    icon: 'fas fa-user-astronaut',
                    path: 'Visitor',
                    pathName: 'visitors',
                    active: false,
                    permission: [
                        permissionConstant.visitor.view
                    ],
                    mode: 'normal'
                }
            ],
            userPermissions: [],
            showSidebar: false,
            sidebar: [],
            mappedTranslation: {
                Dashboard: 'dashboard',
                InquiryAndAttendance: 'inquiryAttendance',
                Employees: 'employeeManagement',
                Pin: 'pin',
                Message: 'messageManagement',
                TimeTableSetting: 'timableSettings',
                Report: 'report',
                Visitor: 'visitor'
            }
        }
    },

    components: {
        BranchSelect,
        LogoutModal,
        LineModal
    },
    computed: {
        username () {
            return localStorage.getItem('username')
        }
    },

    methods: {
        go (mode, path, pathName, module) {
            if (mode === 'normal') {
                this.$router.push({ name: path }, () => {})
                this.$forceUpdate()
                this.setActiveMenu(pathName)
            } else if (mode === 'lineService') {
                this.$refs.lineModal.openModal()
            }
        },

        logout () {
            this.$refs.logoutModal.openModal()
        },

        setActiveMenu (path) {
            for (let i = 0; i < this.items.length; i++) {
                if (path.includes(this.items[i].pathName) && this.items[i].pathName !== '') {
                    this.items[i].active = true
                } else {
                    this.items[i].active = false
                }
            }
        },

        clearSidebar () {
            for (let i = 0; i < this.items.length; i++) {
                this.items[i].active = false
            }
        },

        isActive (isActive) {
            if (isActive) {
                return '#d76436'
            }
        },

        getSidebarPermission () {
            for (let i = 0; i < this.items.length; i++) {
                const show = this.items[i].permission.some(p => this.userPermissions.includes(p)) ||
                    this.items[i].permission.length === 0
                if (show) {
                    this.sidebar.push(this.items[i])
                }
            }
        },

        hideServiceFromEnv () {
            // remove pin menu when env VUE_APP_PIN is false
            if (process.env.VUE_APP_PIN === 'false') {
                const indexOfPinMenu = this.items.findIndex((menu, index) => {
                    if (menu.path === 'Pin') {
                        return true
                    }
                })

                this.items.splice(indexOfPinMenu, 1)
            }

            if (process.env.VUE_APP_MASSAGE_MANAGEMENT === 'false') {
                const indexOfPinMenu = this.items.findIndex((menu, index) => {
                    if (menu.path === 'Message') {
                        return true
                    }
                })

                this.items.splice(indexOfPinMenu, 1)
            }

            if (process.env.VUE_APP_VISITOR === 'false') {
                const indexOfPinMenu = this.items.findIndex((menu, index) => {
                    if (menu.path === 'Visitor') {
                        return true
                    }
                })

                this.items.splice(indexOfPinMenu, 1)
            }
        },

        setLangSideBar () {
            for (let i = 0; i < this.items.length; i++) {
                if (this.mappedTranslation[this.items[i].path]) {
                    this.items[i].title = this.$vuetify.lang.t(`$vuetify.sidebar.${this.mappedTranslation[this.items[i].path]}`)
                }
            }
        }
    },

    async mounted () {
        this.hideServiceFromEnv()
        await this.$store.dispatch('getPermissions')
        this.userPermissions = this.$store.state.permissions
        this.getSidebarPermission()
        this.showSidebar = true
        this.setActiveMenu(this.$router.currentRoute.path)
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.setLangSideBar()
            },
            deep: true
        }
    }
}
</script>
<style lang="scss" scoped>
.sidebar-item {
    display: flex;
}
.v-list-item .normal:hover, .v-list-item .lineService:hover{
    background-color: #888888;
    cursor: pointer;
}
.v-list-item .collapse:hover{
    background-color: #888888;
    cursor: pointer;
}
.pointer {
    cursor: pointer;
}
.v-list {
    padding-left: 0;
    padding-right: 0;
}
.no-highlight {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
}
.img {
    padding: 1rem 0;
    width: 150px;
    opacity: 0.9;
}
.default {
    padding: 1rem 0;
    width: 86px;
}
.center {
    display: flex;
    justify-content: center;
}
.user {
    display: flex;
    color: white;
    padding: 1rem 0.5rem;
}
.username {
    display: flex;
    flex-direction: column-reverse;
    padding-left: 0.5rem;
}
.v-expansion-panel-header {
    padding: 0;
    font-size: 16px;
    background: #131410;
    min-height: 0;
}
.v-expansion-panel:before {
   content: none;
}
.v-expansion-panel-header:hover {
    background-color: #888888;
    cursor: pointer;
}
.sub-menu {
    padding: 0.75rem 3rem;
    &:hover{
        background-color: #888888;
        cursor: pointer;
    }
}
.logout {
    color: white;
}
.sidebar-remain-item {
    padding: 0 8px;
    min-height: 40px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-flex: 1;
    -ms-flex: 1 1;
    flex: 1 1;
    overflow: hidden;
    padding: 12px 0;
    display: flex;
    justify-content: center;
}
.v-list-item {
    padding: 0;
}
.white-text {
   color: white;
}
.sign-out-icon {
    font-size: 20px;
    cursor: pointer;
}
.icon {
    font-size: 21px;
    width: 21px;
}
.active-menu {
    color: #d76436;
}
.sidebar {
    .v-divider, .theme--dark {
        margin: 0rem 1.5rem;
        border-color: white;
    }
}
.power-by {
    font-size: 14px;
}
.version {
    font-weight: 400;
    font-size: 12px;
    color: white;
}
.logout-menu {
    display: flex;
}
.active-icon {
    color: #d76436;
}
</style>
